import { DrmType, ErrorType, LineStatus, MediaType, OrderSourceSystem, OrderType } from './enums';
import { Market } from './market';

export class OrderFilter {
  errorFilter: ErrorType[];
  fromShipDateFilter: (Date | string);
  toShipDateFilter: (Date | string);
  orderTypeFilter: OrderType[];
  mediaFilter: MediaType[];
  statusFilter: LineStatus;
  warningsErrorsFilter: boolean;
  cancelledOrdersFilter: boolean;
  marketFilter: Market[];
  salesRepFilter: string;
  drmFilter: DrmType;
  orderSourceSystemFilter: OrderSourceSystem;
}
